<template functional>
  <el-submenu
    v-if="props.node[props.subMenuKey] && props.node[props.subMenuKey].length"
    :index="props.index"
  >
    <template slot="title">
      <i v-if="props.node[props.iconKey]" class="pagoda-layout-sidemenu-icon" :class="props.node[props.iconKey]"></i>
      <span>{{props.node[props.labelKey]}}</span>
    </template>
    <template v-for="(sub, idx) in props.node[props.subMenuKey]">
      <el-menu-item-group v-if="sub.group">
        <template slot="title">{{sub[props.labelKey]}}</template>
        <el-menu-item
          v-for="(groupItem, _idx) in sub[props.subMenuKey]"
          :key="groupItem[props.labelKey]"
          :node="groupItem"
          :index="`${props.index}-${idx}-${_idx}`"
          :disabled="groupItem.disabled"
          @click="props.handleItemClick(groupItem)"
        >
          <template slot="title">
            <i v-if="groupItem[props.iconKey]" class="pagoda-layout-sidemenu-icon" :class="groupItem[props.iconKey]"></i>
            <span>{{groupItem[props.labelKey]}}</span>
          </template>
        </el-menu-item>
      </el-menu-item-group>
      <sub-menu
        v-else
        :node="sub"
        :labelKey="props.labelKey"
        :subMenuKey="props.subMenuKey"
        :handleItemClick="props.handleItemClick"
        :index="`${props.index}-${idx}`"
      ></sub-menu>
    </template>
  </el-submenu>
  <el-menu-item
    v-else
    :node="props.node"
    :index="props.index"
    :disabled="props.node.disabled"
    @click="props.handleItemClick(props.node)"
  >
    <i v-if="props.node[props.iconKey]" :class="props.node[props.iconKey]"></i>
    <span slot="title">{{props.node[props.labelKey]}}</span>
  </el-menu-item>
</template>

<script>
  import {
    getEmptyObject,
    noop
  } from "../../../utils";

  import SubMenu from './sub-menu'

  export default {
    name: 'PagodaSubMenu',
    props: {
      node: {
        type: Object,
        default: getEmptyObject
      },
      index: String,
      handleItemClick: {
        type: Function,
        default: noop
      },
      labelKey: String,
      subMenuKey: String,
      urlKey: String,
      iconKey: String
    },
    components: {
      SubMenu
    }
  }
</script>